module.exports = __webpack_public_path__ + "static/img/addressCall.d0e127d6.png";